import { getPlatform } from "@/api";

const state = {
  // 相关推荐
  recommends: [],

  platform: {},
};

const mutations = {
  SET_RECOMMENDS: (state, recommends) => {
    if (Array.isArray(recommends)) {
      state.recommends = recommends;
    } else {
      state.recommends = [];
    }
  },
  SET_PLATFORM: (state, platform) => {
    state.platform = platform;
  },
};

const actions = {
  getPlatformInfo: async ({ commit }) => {
    try {
      const { code, data, message } = await getPlatform();

      if (code !== 0) throw new Error(message);

      commit("SET_PLATFORM", data);
    } catch (error) {
      commit("SET_PLATFORM", {});
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
